import {Text} from '@primer/react'

import styles from './shared.module.css'

export const selectorDropdownButtonStyles = {
  flex: 1,
  gridTemplateColumns: 'min-content 1fr min-content',
  textAlign: 'left',
  width: '100%',
  '[data-component=buttonContent]': {flex: 0},
}

// Setting the width because the dropdown in rendered in a portal, 400 (bar width) - 24x2 (x padding) - 1 (border)
export const selectorDropdownOverlayStyles = {width: `${400 - 24 * 2 + 1}px`}

export const SelectorLabel = ({children, sx, ...props}: React.ComponentProps<typeof Text>) => (
  <Text sx={sx} className={styles.Text} {...props}>
    {children}
  </Text>
)

try{ SelectorLabel.displayName ||= 'SelectorLabel' } catch {}